import qrcode from '@/router/qrcode.js'
import ctnManage from '@/router/content-manage.js'
import systemSettings from "@/router/system-settings.js"
import activityManage from "@/router/activity-manage.js"
import lifeHome from "@/router/life-home.js"
import live from "@/router/live.js"


let customRouters = []

// 注释掉"选择进入店铺"路由
// customRouters.push({
//     path: '/select-shop',
//     component: resolve => require(['@/components/conf/select-shop/select-shop.vue'], resolve),
//     name: "选择进入店铺",
//     hidden: true
// })
customRouters.push(qrcode)
customRouters.push(ctnManage)
customRouters.push(systemSettings)
customRouters.push(activityManage)
customRouters.push(lifeHome)
customRouters.push(live)

//自定义的router配置；
export default customRouters



// WEBPACK FOOTER //
// ./src/router/custom-router.js